import {
  Grid,
  Container,
  Typography,
  Box,
  Alert,
  IconButton,
  Snackbar,
} from "@mui/material";
import { styles } from "./styles";
import Logout from "../../Components/Logout";
import Downloader from "../Downloader/Downloader";
import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";

export interface AlertMessage {
  message: string;
  key: number;
  type?: "success" | "error";
}

const Home = () => {
  const [alertList, setAlertList] = useState<AlertMessage[]>([]);
  const [open, setOpen] = useState(false);
  const [messageInfo, setMessageInfo] = useState<AlertMessage | undefined>(
    undefined,
  );

  useEffect(() => {
    if (alertList.length && !messageInfo) {
      setMessageInfo({ ...alertList[0] });
      setAlertList((prev) => prev.slice(1));
      setOpen(true);
    } else if (alertList.length && messageInfo && open) {
      setTimeout(() => setOpen(false), 3000);
    }
  }, [alertList, setAlertList, messageInfo, open]);

  const handleAlertClose = (
    event: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleAlertExited = () => {
    setMessageInfo(undefined);
  };

  return (
    <Box
      sx={(theme) => ({ backgroundColor: theme.palette.background.default })}
    >
      <Container>
        <Snackbar
          key={messageInfo ? messageInfo.key : undefined}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={open}
          autoHideDuration={5000}
          onClose={handleAlertClose}
          TransitionProps={{ onExited: handleAlertExited }}
        >
          <Alert
            severity={messageInfo?.type ? messageInfo.type : "error"}
            variant="filled"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleAlertClose}
              >
                <Close fontSize="inherit" />
              </IconButton>
            }
          >
            {messageInfo?.message}
          </Alert>
        </Snackbar>
        <Grid
          container
          spacing={2}
          direction={"row"}
          justifyContent={"flex-end"}
        >
          <Grid size={1}>
            <Logout />
          </Grid>
        </Grid>
        <Grid container spacing={2} direction={"column"}>
          <Grid size={12}>
            <Typography variant="h1" sx={styles.homeTitle}>
              Bible Brain Downloader
            </Typography>
          </Grid>
          <Grid size={12}>
            <Downloader setAlertList={setAlertList} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Home;
